import { Button } from '@service-victoria/component-library/components/Button';
import React, { CSSProperties, useEffect } from 'react';
import ReactModal, { Styles } from 'react-modal';

import { APP_ROOT } from 'utils/constants';

import { ComponentProps } from './interfaces';
import * as Styled from './styled';

const overlayStyles: CSSProperties = {
  backgroundColor: 'rgba(142, 144, 147, 0.6)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};
const contentStyles: CSSProperties = {
  position: 'static',
  width: 'calc(100% - 16px)',
  maxWidth: '768px',
  maxHeight: '95vh',
  margin: '8px 8px 0 8px',
  borderRadius: '0',
  border: 'none',
  padding: '0',
  boxShadow: '0 3px 7px 6px rgba(121, 121, 121, 0.5)'
};
const customStyles = {
  overlay: overlayStyles,
  content: contentStyles
};

ReactModal.setAppElement(`#${APP_ROOT}`);

export const Modal: React.FC<ComponentProps> = ({
  isOpen = false,
  title,
  children,
  closeHandler,
  cancelHandler,
  cancelText,
  canEscape = false,
  actions
}) => {
  const titleRef = React.useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        titleRef.current?.focus();
      }, 0);
    }
  }, [isOpen]);

  return (
    <ReactModal
      contentLabel='modal-contentLabel'
      isOpen={isOpen}
      style={customStyles as Styles}
      {...(canEscape ? { onRequestClose: closeHandler } : {})}>
      <Styled.Wrapper>
        <Styled.TopBar>
          {title && (
            <Styled.ModalTitle tabIndex={-1} ref={titleRef} data-testid='ModalTitle'>
              {title}
            </Styled.ModalTitle>
          )}
          <Styled.IconContainer
            onClick={closeHandler}
            aria-label='Close dialog'
            data-testid='ModalClose'>
            <Styled.IconBox />
          </Styled.IconContainer>
        </Styled.TopBar>
        <Styled.ModalBody data-testid='ModalBody' id='modal-contentLabel' hasActions={!!actions}>
          {children}
          {actions && (
            <Styled.ActionsContainer data-testid='ModalActions'>
              {actions.map((action, i) => {
                const { label, onClick } = action;
                return (
                  <Button
                    key={`${label}_${i}`}
                    onClick={onClick}
                    data-testid={`ModalPrimaryButton${i}`}>
                    {label}
                  </Button>
                );
              })}
              <Button
                buttonType='secondary'
                onClick={cancelHandler ?? closeHandler}
                data-testid='ModalSecondaryButton'>
                {cancelText ?? 'Cancel'}
              </Button>
            </Styled.ActionsContainer>
          )}
        </Styled.ModalBody>
      </Styled.Wrapper>
    </ReactModal>
  );
};

export default Modal;
